import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const MeasurableId = iotsUtils.fromList(constants.job.volumetrics.measurableIds);

export const UniqueTrussTypesId = iotsUtils.fromList(constants.job.volumetrics.uniqueTrussTypesIds);
